import { render, staticRenderFns } from "./confirm_info.vue?vue&type=template&id=5bb5fa3e&"
import script from "./confirm_info.vue?vue&type=script&lang=js&"
export * from "./confirm_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports